module.exports = __webpack_public_path__ + "img/外网_03.dd40d7a3.jpg";